import { render, staticRenderFns } from "./text-editor-readonly.vue?vue&type=template&id=7b81c682"
import script from "./text-editor-readonly.vue?vue&type=script&lang=js"
export * from "./text-editor-readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports